import axios from "axios";
import { del, get, post, patch,  put } from "./document_types_api_helper";
import * as url from "./document_types_url_helper";





// Get features
export const getDocumentTypes = () => get(url.GET_DOCUMENT_TYPES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewDocumentType = documentType => post(url.ADD_NEW_DOCUMENT_TYPE, documentType);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateDocumentType = documentType => patch(`${url.UPDATE_DOCUMENT_TYPE}/${documentType.id}`,  documentType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteDocumentType = documentType => del(`${url.DELETE_DOCUMENT_TYPE}/${documentType.id}`);







export {
  //getLoggedInUser,
  
  
};
